/*
 * What `:tada:` becomes as the closing colon is typed. It is the one thing the composer's emoji
 * table does for the editor, and it stands here rather than inside the input rules because a rule
 * is the same in every dialect while the table is this surface's: an editor over another dialect
 * has no emoji list and passes no lookup at all.
 */

import { emojiSkinTone } from "../emoji/recents.ts"
import { loadedEmojiTable, withSkinTone } from "../emoji/table.ts"

/**
 * The table's character in the person's skin tone, and null while the table is not here yet (the
 * autocomplete list's first query loads it) or does not know the code — the shortcode then stays
 * text, which is what the server reads anyway.
 */
export function emojiCharacter(shortcode: string): string | null {
	const entry = loadedEmojiTable()?.byShortcode(shortcode)
	return entry === undefined ? null : withSkinTone(entry, emojiSkinTone())
}
